import { render, staticRenderFns } from "./wf-overridable-optional-duration-display.vue?vue&type=template&id=6dd4ec1b&scoped=true&"
import script from "./wf-overridable-optional-duration-display.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-optional-duration-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-optional-duration-display.vue?vue&type=style&index=0&id=6dd4ec1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4ec1b",
  null
  
)

export default component.exports